










































































































interface IfilterBar {
  status: string | null;
  username: string | null;
  email: string | null;
  fullName: string | null;
  phone: string | null;
}
interface Ipagination {
  currentPage: number;
  pageSize: number;
  total: number;
}
import { Component, Vue, Ref } from 'vue-property-decorator';
import ResetPasswordDialog from './dialog/resetPasswordDialog.vue';
import DetailDrawer from './drawer/detailDrawer.vue';
import TipDiaog from './dialog/tipDialog.vue';
import { getUserList, setBatchEnable } from '@/utils/api';

@Component({
  name: 'userManageView',
  components: { ResetPasswordDialog, DetailDrawer, TipDiaog },
})
export default class UserManageView extends Vue {
  @Ref('resetPasswordDialogRef') resetPasswordDialogRef!: any;
  @Ref('detailDrawerRef') detailDrawerRef!: any;
  @Ref('tipDiaogRef') tipDiaogRef!: any;
  @Ref('pubFeTableRef') pubFeTableRef!: any;
  filterBar: IfilterBar = {
    status: 'VALID',
    username: null,
    email: null,
    fullName: null,
    phone: null,
  };
  tableData: Array<object> = [];
  tableLoading: boolean = false;
  pagination: Ipagination = {
    currentPage: 1,
    pageSize: 10,
    total: 0,
  };
  selectRowIdData: Array<string> = [];
  statusCodeOption: Array<object> = [
    {
      label: '启用',
      value: 'VALID',
    },
    {
      label: '停用',
      value: 'INVALID',
    },
  ];

  /*
   *@description:'清楚用户选择'
   */
  clearCheckboxReserveEvent() {
    this.$nextTick(() => {
      this.pubFeTableRef.clearCheckboxReserveEvent();
    });
  }

  /*
   *@description:'查询'
   */
  queryMethod(val) {
    this.clearCheckboxReserveEvent();
    this.tableLoading = true;
    const { filterBar, pagination } = this;
    const pageNum = val === 'size' ? 0 : pagination.currentPage - 1;
    if (val === 'size') {
      this.pagination.currentPage = 1;
    }
    const params = {
      status: filterBar.status,
      username: filterBar.username,
      email: filterBar.email,
      fullName: filterBar.fullName,
      phone: filterBar.phone,
      page: pageNum,
      size: pagination.pageSize,
    };
    getUserList(params)
      .then((res: any) => {
        const { content = [], totalElements = 0 } = res;
        this.tableData = content;
        this.pagination.total = totalElements;
      })
      .catch((err) => {
        console.log('err:userManageView', err);
      })
      .finally(() => {
        this.tableLoading = false;
      });
  }
  /*
   *@description:'重置筛选栏'
   */
  resetMethod() {
    this.filterBar = {
      status: 'VALID',
      username: null,
      email: null,
      fullName: null,
      phone: null,
    };
  }

  /*
   *@description:'单个启用/停用'
   */
  batchMethod(rowData: any): void {
    const { status, username } = rowData;
    const statusCode = status === 'VALID' ? 'INVALID' : 'VALID';
    const tipMessage = status === 'VALID' ? '停用成功' : '启用成功';
    const data = {
      status: statusCode,
      usernames: [username],
    };
    setBatchEnable(data)
      .then((res) => {
        this.$message.success(tipMessage);
        this.queryMethod('size');
      })
      .catch((err) => {
        console.log('err:userManageView ', err);
      });
  }

  created() {
    const { queryMethod } = this;
    queryMethod('size');
  }
}
